import React from 'react';
import ValidationText from '../validationText';
import InputField from '../inputField';

const InputSearchBox = ({
  srchLbl,
  srchID,
  srchPlaceholder,
  registerFunction,
  handleInput,
  inputValue,
  clearInputValue,
  isText,
  placeholderLabel,
  hiddenlabel,
  isInputActive,
  setIsInputActive
}) => {
  const onIconHandler = () => {
    if (inputValue && inputValue.trim().length > 0) {
      // If input has text, clear it and close
      clearInputValue();
    } else {
      // If input is empty, toggle open/close state
      setIsInputActive((prev) => !prev);
    }
  };

  return (
    <InputField
      parentExtraCls={isInputActive ? 'si-active' : ''}
      inputLbl={window?.['translations']?.['searchlabel'] || ''}
      inputID={srchID}
      inputType='text'
      placeholderIcon='lms-search'
      placeholderLabel={placeholderLabel}
      isDisabled=''
      extraAttri=''
      hiddenlabel={false}
      components={false && <ValidationText validationText='required' />}
      inputValidate={false}
      isIcon={isInputActive && inputValue ? 'lms-close' : 'lms-search'}
      isText={isText}
      handleInput={handleInput}
      iconClickHandler={onIconHandler}
      inputText={inputValue}
      ismaxlength={false}
    />
  );
};

export default InputSearchBox;
